import { useSyncExternalStore } from 'react'
import { createTravels, TravelPatches, Travels } from 'travels'
import { ViewerConfig } from '@/components/Viewer'

// happy-todo: move/rename

type UndoRedo = {
  current: Travels<ViewerConfig> | null
  stateChangeDescriptions: string[]
}

const undoRedo: UndoRedo = {
  current: null,
  stateChangeDescriptions: []
} as const

export function initializeViewerUndoRedo(params: {
  initialState: ViewerConfig,
  onStateUpdated: (newViewer: ViewerConfig, patches: TravelPatches, position: number) => void
}) {
  undoRedo.current = createTravels(params.initialState)
  undoRedo.stateChangeDescriptions = []

  undoRedo.current!.subscribe((state, patches, position) => {
    params.onStateUpdated(state, patches, position)
  })
}

export function saveViewerSnapshot(currentViewer: ViewerConfig, description?: string) {
  const travels = undoRedo.current
  if (!travels) throw new Error("Initial viewer snapshot not saved yet")
  travels.setState(currentViewer)
  undoRedo.stateChangeDescriptions.push(description ?? "")
}

export function getViewerUndoRedo() {
  return undoRedo.current
}

export function useViewerUndoRedo() {
  const viewerSnapshot = useSyncExternalStore(
    (onStoreChange) => {
      if (!undoRedo.current) return () => {}
      return undoRedo.current!.subscribe(onStoreChange)
    }, () => {
      if (!undoRedo.current) return null
      return undoRedo.current.getState()
    }
  )

  const pos = undoRedo.current?.getPosition() ?? -1
  const prevStateDescription = undoRedo.stateChangeDescriptions[pos - 1]
  const nextStateDescription = undoRedo.stateChangeDescriptions[pos]

  return [
    viewerSnapshot,
    undoRedo.current?.getControls(),
    prevStateDescription,
    nextStateDescription,
  ] as const;
}
